import styled from "styled-components";
import { getBreakpoint } from "../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { IconWrapper } from "../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";

export const Wrapper = styled.div`
    margin: ${theme.space[3]}px 0;
    padding: ${theme.space[3]}px;
    font-size: 1.3rem;
    text-align: start;
    background-color: ${theme.colors.mist};
`;

export const Item = styled.div`
    display: inline-flex;
    align-items: center;
    column-gap: ${theme.space[1]}px;
    width: 100%;
    max-width: 50%;
    color: ${theme.colors.midnight};

    ${IconWrapper} {
        display: flex;
        align-items: center;
    }

    @media ${getBreakpoint("up", "md")} {
        width: auto;
        max-width: none;
        margin-right: ${theme.space[3]}px;
    }

    html[dir="rtl"] & {
        @media ${getBreakpoint("up", "md")} {
            margin-left: ${theme.space[3]}px;
            margin-right: 0;
        }
    }
`;
